module.exports = __webpack_public_path__ + "img/logo51.c44964ab.png";